<script setup lang="ts">
import MmIcon from '../base/MmIcon.vue'
import { useBadgeCatalog } from './useBadgeCatalog'
import { chartDescription } from './insights/format'
import { badgeMetadata } from './contracts.mjs'
const props = withDefaults(defineProps<{ badge?: { badge_key: string; tier?: number } | string | null; fallbackLabel: string; size?: number }>(), { size: 16 })
const { t, te, locale } = useI18n()
const key = computed(() => typeof props.badge === 'string' ? props.badge : props.badge?.badge_key || '')
const { definitions, apiBase } = useBadgeCatalog(computed(() => !!key.value))
const definition = computed(() => definitions.value.find(item => item.key === key.value))
const metadata = computed(() => definition.value ? badgeMetadata(definition.value, locale.value, t, te, apiBase) : null)
const label = computed(() => metadata.value ? [metadata.value.name, chartDescription(key.value, metadata.value.description, t)].filter(Boolean).join(' · ') : props.fallbackLabel)
const primary = computed(() => metadata.value?.iconUrl || '')
const source = computed(() => !failed.value ? primary.value : '')
const image = ref<HTMLImageElement | null>(null)
const failed = ref(false), generation = ref(0)
const checkImage = () => { if (image.value?.complete && image.value.naturalWidth === 0) onImageError.value() }
const onImageError = computed(() => {
  const current = generation.value, src = source.value
  return () => { if (current !== generation.value || src !== source.value) return; failed.value = true }
})
watch([key, primary], () => { generation.value++; failed.value = false }, { flush: 'sync' })
watch(source, () => { generation.value++; void nextTick(checkImage) }, { flush: 'sync' })
watch(image, checkImage, { flush: 'post' })
onMounted(checkImage)
</script>
<template><span v-if="badge" class="public-creator-badge" role="img" :aria-label="label" :title="label"><img v-if="source" :key="source" ref="image" :src="source" :alt="metadata?.name || fallbackLabel" :width="size" :height="size" loading="lazy" decoding="async" referrerpolicy="no-referrer" :onError="onImageError"><MmIcon v-else name="image" :size="size" :title="t('incRewards.imageUnavailable')" /></span></template>
<style scoped>
.public-creator-badge { display: inline-flex; flex: none; vertical-align: middle; color: var(--accent-text); }
.public-creator-badge img { display: block; object-fit: contain; }
</style>
